import React from 'react';
import DOMPurify from 'dompurify';
import Image from '../PostComponents/Image';
import SmallPostDummy from '../Dummies/SmallPostDummy';
import Ad from '../PostComponents/Ad';

class SmallPost extends React.Component {
    constructor(props) {
        super(props);

        this.post = this.props.data;
        this.rowCount = this.props.rowCount ?? 4;
        this.postsBeforeAd = this.rowCount * 2;

    }

    render() {
        const columnSize = 12 / this.rowCount;

        if (typeof this.post == 'undefined') {
            return <SmallPostDummy columnSize={columnSize} />
        }

        const shortContent = DOMPurify.sanitize(this.post.excerpt);


        return (
            <React.Fragment>
                <div className={`col-6 col-lg-${columnSize} ${this.props.className}`} {...this.props.attributes}>
                    <div className="post post--small d-flex flex-column">
                        {this.post.featured_image && 
                            <a href={this.post.url} className="d-block">
                                <Image className="post_image" image={this.post.featured_image.url} alt={this.post.featured_image.title || this.post.title} width={307.5} height={200} />
                            </a>
                        }
                        <a href={this.post.url} className="d-block post_title">
                            <h2>{this.post.title}</h2>
                        </a>
                        <div className="post_head">
                            {this.post.categories[0] && (
                                <div className="post_category">
                                    <a href={`${this.post.categories[0].url}`}>{this.post.categories[0].name}</a>
                                </div>
                            )
                            }
                            <span className="post_date">{this.post.date_text}</span>
                        </div>
                        <div className="post_content" dangerouslySetInnerHTML={{__html: shortContent}}>
                        </div>
                    </div>
                </div>
                {(this.props.infinityIndex % this.postsBeforeAd == 0 
                    && this.props.infinityIndex <= 8 * this.postsBeforeAd ) &&
                    <div className="col-12">
                        <Ad nbr={this.props.infinityIndex / this.postsBeforeAd} type="small" fitAdsToContent={this.props.fitAdsToContent}/>
                    </div>
                }
            </React.Fragment>
        )
    }
}

export default SmallPost;